let rows: HTMLElement[];

interface IDestroyHandler {
    event?: string;
    element: Element;
    handler: () => void;
}

const destroyHandlers: IDestroyHandler[] = [];

const handlePrimaryButtonClickClosure = (row: Element) => () => {
    const isItemActive = row.classList.contains('active');

    rows.forEach((row) => {
        row.classList.remove('active');

        const collapseElement = row.querySelector<HTMLElement>('.js-ph-collapse');

        if (collapseElement) {
            collapseElement.style.height = '0px';
        }
    });

    if (!isItemActive) {
        row.classList.add('active');

        const rowCollapseElement = row.querySelector<HTMLElement>('.js-ph-collapse');

        if (rowCollapseElement) {
            rowCollapseElement.style.height = `${rowCollapseElement.scrollHeight}px`;
        }
    }
};

const init = () => {
    rows = Array.from(document.querySelectorAll<HTMLElement>('.js-ph-row'));

    rows.forEach((row) => {
        const primaryButton = row.querySelector('.js-ph-primary');

        if (primaryButton) {
            const handlePrimaryButtonClick = handlePrimaryButtonClickClosure(row);

            primaryButton.addEventListener('click', handlePrimaryButtonClick);

            destroyHandlers.push({ handler: handlePrimaryButtonClick, element: primaryButton });
        }
    });
};

const destroy = () => {
    destroyHandlers.forEach((handlerItem) => {
        handlerItem.element.removeEventListener(handlerItem.event ?? 'click', handlerItem.handler);
    });
};

const _module = { init, destroy };

export default _module;
